export var quiztypeenum={
    'graded_quiz':'qztype1',
    'personality_quiz':'qztype2',
    'feedback':'qztype3',
    'poll':'qztype4',
    'graded_quiz_with_personality':'qztype5',
    'weighted_graded_quiz':'qztype6',
    'multiple_personality_quiz':'qztype7',
    'category_quiz_multiple_personality':'qztype8',
    'category_graded_quiz_with_personality':'qztype9',
}



